export enum HrPartnersEnum {
  HRAM = 'HR Area Manager',
  HRBP = 'HR Business Partner',
  HRFD = 'HR Field Director',
  HRSTA = 'HR Senior Talent Acquisition',
  HRTAP = 'HR Talent Acquisition Partner',
}
